import { gql } from "@apollo/client";
import { RegisteredVehicleSummary, registeredVehicleSummaryFragment } from "./registeredVehicleFragment";

export const policyVehicleExemptionSummaryFragment = gql`
  fragment policyVehicleExemptionSummaryFragment on policy_vehicle_exemption {
    id
    registeredVehicle: registered_vehicle {
      ...registeredVehicleSummaryFragment
    }
    licensePlateNumberLike: license_plate_number_like
    licensePlateStateCodeLike: license_plate_state_code_like
    beginAt: begin_at
    endAt: end_at
    vehicleDescription: vehicle_description
  }
  ${registeredVehicleSummaryFragment}
`;

export interface PolicyVehicleExemptionSummary {
  id: string;
  registeredVehicle?: RegisteredVehicleSummary;
  licensePlateNumberLike: string;
  licensePlateStateCodeLike: string;
  beginAt: string;
  endAt: string;
  vehicleDescription: string | null;
}
